import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  codebookColumnValueList: [],
  codebookColumnValue: {},
  loading: false,
  error: undefined,
};

const codeCodebookColumnValueSlice = createSlice({
  name: 'codeCodebookColumnValue',
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    actionError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    savecodebookColumnValues(state, action) {
      state.codebookColumnValueList = action.payload || [];
      state.error = undefined;
      state.loading = false;
    },
    fetchAllcodebookColumnValues(state, action) {
      state.codebookColumnValueList = action.payload;
      state.error = undefined;
      state.loading = false;
    },
    fetchAllCodebookColumnValuesList(state, action) {
      state.codebookColumnValueList = action.payload;
      state.error = undefined;
      state.loading = false;
    },
    clearAllCodebookColumnValues(state) {
      state.codebookColumnValueList = [];
      state.error = undefined;
      state.loading = false;
    },
  },
});

export const codeCodebookColumnValueActions =
  codeCodebookColumnValueSlice.actions;

export default codeCodebookColumnValueSlice.reducer;
